export default "__VITE_ASSET__9bfea2ae__"